import Vue from 'vue'
import App from './App.vue'
// import VConsole from 'vconsole';
Vue.config.productionTip = false
// let vConsole = new VConsole();
// console.log('Hello vConsole')
new Vue({
  render: h => h(App),
}).$mount('#app')
